import React, { useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { hasPaintedOnce } from "./firstPaint";

const scrollRevealVariants = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.4, 0, 0.2, 1],
    },
  },
};

function ScrollReveal({ children, delay = 0, threshold = 0.1 }) {
  const [ref, inView] = useInView({
    threshold: threshold,
    triggerOnce: true,
  });

  // Same rule as PageTransition: always render a motion.div, never swap element
  // types between renders. On the first page of a session content is simply
  // shown — no reveal — so a page load doesn't flash its own content in.
  // Reduced motion takes the same path: content is there, it just doesn't move.
  const reduceMotion = useReducedMotion();
  const skipEntrance = useRef(!hasPaintedOnce()).current || reduceMotion;

  return (
    <motion.div
      ref={ref}
      initial={skipEntrance ? false : "hidden"}
      animate={skipEntrance || inView ? "visible" : "hidden"}
      variants={{
        hidden: scrollRevealVariants.hidden,
        visible: {
          ...scrollRevealVariants.visible,
          transition: {
            ...scrollRevealVariants.visible.transition,
            delay: delay,
          },
        },
      }}
    >
      {children}
    </motion.div>
  );
}

export default ScrollReveal;
